import React from 'react'
import { ModalComp } from '../Modal'

const message = {
  type: 'Info',
  text: 'We\'re sorry! Something went wrong and your changes were not saved.',
  titleLabel: 'Error'
}

const ErrorModal = ({ isOpen, toggleModal }) => <ModalComp isOpen={isOpen} message={message} actions={[{ label: 'OK', handler: toggleModal }]} />

export default ErrorModal
